// -----------------------------------------------------------------------------
// スナックバー 型定義
// -----------------------------------------------------------------------------
// アクション種別
export default {
  ADD: 'SNACKBAR/ADD',    // メッセージを追加
  DEL: 'SNACKBAR/DEL',    // メッセージを削除
  CLR: 'SNACKBAR/CLR',    // メッセージをクリア
};

/**
 * スナックメッセージ
 */
export class SnackMessage {
  /** デフォルトの表示時間(ミリ秒) */
  static DURATION = 5000;

  /** 重要度 - 通常 */
  static NORMAL = 0;

  /** 重要度 - 高 */
  static HIGH = 1;

  /** 重要度 - 低 */
  static LOW = -1;

  /**
   * コンストラクタ
   *
   * @param {String} id - メッセージID
   * @param {Array<Object>} args - メッセージ引数
   * @param {String} category - 表示区分(画面ID)
   * @param {Number} duration - 表示時間(ミリ秒)
   * @param {Number} severity - 重要度
   */
  constructor(
      id, args,
      category,
      duration = SnackMessage.DURATION,
      severity = SnackMessage.NORMAL) {
    this.id = id;
    this.args = Array.isArray(args) ? args : [];
    this.time = new Date().getTime();
    this.hash = null;
    this.category = category;
    this.duration = Number.isFinite(duration) ? duration : 0;
    this.severity = Number.isFinite(severity) ? severity : SnackMessage.LOW;
  }

  /**
   * ハッシュ値計算
   *
   * - メッセージIDとメッセージ引数からハッシュ値を計算する
   * - これがメッセージオブジェクトを一意に識別する値となる
   */
  makeHash = async function() {
    if (!this.hash) {
      const text = [this.id, ...this.args].join('|');
      const utf8 = new TextEncoder().encode(text);
      const hash = await crypto.subtle.digest('SHA-1', utf8);
      const buff = Array.from(new Uint8Array(hash));
      this.hash = buff.map((b) => b.toString(16).padStart(2, '0')).join('');
    }
    return this;
  };

  /**
   * メッセージファクトリー
   *
   * @param {String} msgId - メッセージID
   * @param {Array<Object>} msgArgs - メッセージ引数
   * @param {String} category - 表示区分(画面ID)
   * @return {Promise<SnackMessage>} メッセージオブジェクト
   */
  static create = async function(msgId, msgArgs, category) {
    return new SnackMessage(msgId, msgArgs, category).makeHash();
  };

  /**
   * メッセージコピー
   *
   * @param {SnackMessage} src - コピー元メッセージ
   * @return {SnackMessage} コピーした新しいメッセージ
   */
  static copy = function(src) {
    const message = new SnackMessage(
        src.id,
        src.args,
        src.category,
        src.duration,
        src.severity);
    message.time = src.time;
    message.hash = src.hash;
    return message;
  };
}
